<div class="w-full flex flex-col gap-0 mt-2">
  <!-- Total Price -->
  <div class="flex flex-row p-2 px-4">
    <div class="flex-1">
      {{ 'Total Price' | translate }}
    </div>
    <div class="flex-1 text-right" data-qa="reservation-price-total">
      {{
        $safeNavigationMigration(reservation.paymentInSellCurrency?.price)
          | priceFormat
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
      }}
    </div>
    <div class="flex-1 text-right">
      {{
        $safeNavigationMigration(reservation.paymentInOutInvCurrency?.price)
          | priceFormat: $safeNavigationMigration(reservation.paymentInOutInvCurrency?.currencyCode)
      }}
    </div>
  </div>

  <!-- Net Price -->
  <div class="flex flex-row p-2 px-4">
    <div class="flex-1">
      {{ 'Net Price' | translate }}
    </div>
    <div class="flex-1 text-right" data-qa="reservation-price-net">
      {{
        $safeNavigationMigration(reservation.paymentInSellCurrency?.netPrice)
          | priceFormat
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
      }}
    </div>
    <div class="flex-1 text-right">
      {{
        $safeNavigationMigration(reservation.paymentInOutInvCurrency?.netPrice)
          | priceFormat: $safeNavigationMigration(reservation.paymentInOutInvCurrency?.currencyCode)
      }}
    </div>
  </div>

  <!-- Paid -->
  <div class="flex flex-row p-2 px-4">
    <div class="flex-1">
      {{ 'Paid' | translate }}
    </div>
    <div class="flex-1 text-right" data-qa="reservation-price-paid">
      {{
        $safeNavigationMigration(reservation.paymentInSellCurrency?.paid)
          | priceFormat
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
      }}
    </div>
    <div class="flex-1 text-right">
      {{
        $safeNavigationMigration(reservation.paymentInOutInvCurrency?.paid)
          | priceFormat: $safeNavigationMigration(reservation.paymentInOutInvCurrency?.currencyCode)
      }}
    </div>
  </div>

  <!-- Unpaid -->
  <div class="flex flex-row p-2 px-4 text-kz-primary">
    <div class="flex-1">
      {{ 'Amount to be paid' | translate }}
    </div>
    <div class="flex-1 text-right" data-qa="reservation-price-unpaid">
      {{
        $safeNavigationMigration(reservation.paymentInSellCurrency?.unpaid)
          | priceFormat
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
      }}
    </div>
    <div class="flex-1 text-right">
      {{
        $safeNavigationMigration(reservation.paymentInOutInvCurrency?.unpaid)
          | priceFormat: $safeNavigationMigration(reservation.paymentInOutInvCurrency?.currencyCode)
      }}
    </div>
  </div>

  <!-- Comission -->
  <div class="flex flex-row p-2 px-4 bg-kz-layout-featured">
    <div class="flex-1">
      {{ 'Comission' | translate }}
    </div>
    <div class="flex-1 text-right" data-qa="reservation-price-commission">
      {{
        $safeNavigationMigration(reservation.paymentInSellCurrency?.comission)
          | priceFormat
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
            : $safeNavigationMigration(reservation.paymentInSellCurrency?.currencyCode)
      }}
    </div>
    <div class="flex-1 text-right">
      {{
        $safeNavigationMigration(reservation.paymentInOutInvCurrency?.comission)
          | priceFormat: $safeNavigationMigration(reservation.paymentInOutInvCurrency?.currencyCode)
      }}
    </div>
  </div>

  <!-- Comission Percent -->
  <div class="flex flex-row p-2 px-4">
    <div class="flex-1">{{ 'Comission' | translate }} (%)</div>
    <div class="flex-1 text-right">{{ reservation.paymentInOutInvCurrency?.comissionPercent }} %</div>
  </div>
  <!-- ADLC-4 R-W4: the next payment and the steps of the reservation's payment schedule (display only, D1) -->
  <app-next-payment variant="prices" [reservation]="reservation" />
</div>

<ng-template #modalFooterTemplateRef>
  <div class="py-2 flex flex-wrap px-2 items-center justify-end gap-x-8 gap-y-2" data-qa="reservation-price-footer">
    <button
      class="link-btn reverse-primary uppercase!"
      type="button"
      data-qa="reservation-price-close-button"
      (click)="onDynamicModalClose()"
    >
      {{ 'Close' | translate }}
    </button>
    <!-- product invoices R-PI29: one Download Invoice per live agency invoice (hotel + cruise = two, both numbered as the reservation's first -
         told apart by the amount); without the list (rule R-3 refused, or an older API) the single button as before -->
    @if (invoices.length > 0) {
      @for (invoice of invoices; track invoice.id; let index = $index) {
        <button
          mat-flat-button
          color="primary"
          class="min-h-9! h-auto! max-w-full"
          type="button"
          [attr.data-qa]="invoiceTestId(invoice)"
          [disabled]="downloadingUrl() !== null && downloadingUrl() !== invoice.url"
          [loading]="downloadingUrl() === invoice.url"
          (click)="onDownloadInvoiceOf(invoice, index)"
        >
          {{ 'Download Invoice' | translate }}
          <span class="whitespace-nowrap" [attr.data-qa]="invoiceTestId(invoice) + '-label'"
            >№ {{ invoice.number }}
            @if (invoice.amount !== null && invoice.amount !== undefined) {
              · {{ invoice.amount | priceFormat: invoice.currencyCode : invoice.currencyCode }}
            }
          </span>
        </button>
      }
    } @else {
      <button
        mat-flat-button
        color="primary"
        class="h-9!"
        type="button"
        data-qa="reservation-invoice-download-button"
        [disabled]="!reservation.invoiceUrl"
        [loading]="downloadDocumentLoadState().status === 'loading'"
        (click)="onDownloadInvoice()"
      >
        {{ 'Download Invoice' | translate }}
      </button>
    }
  </div>
</ng-template>
